import AddInterviewDialog from 'addInterview/AddInterviewDialog';
import { InterviewCreationFormValues } from './types';
import AddNewGroupDialog from 'addInterview/AddNewGroupDialog';

interface Props {
    onClose: () => void;
    interviewCreationFormValues: InterviewCreationFormValues | false;
}

export function CreateGroupOrInterviewModal({ interviewCreationFormValues, onClose }: Props) {
    if (!interviewCreationFormValues) {
        return null;
    }

    // if we have a group id, show "add interview" dialog
    if (interviewCreationFormValues?.groupId) {
        return <AddInterviewDialog onClose={onClose} {...interviewCreationFormValues} />;
    } else {
        return <AddNewGroupDialog onClose={onClose} {...interviewCreationFormValues} />;
    }
}
